// extracted by mini-css-extract-plugin
module.exports = {"ImageX":"_1x22G","imageX":"_1x22G","linkWithEffect":"_3C3V_"};